<template>
  <div class="workorder-banner">
    <img :src="workorderBanner" alt="" />
    <div class="absolute">
      <div class="title">数字家园工单系统</div>
      <div class="text">
        聚焦后台物业工单，智能统筹，实时部署，赋能物业，连接业主，实现智慧物业立体化管理，促进物业服务新模式升级。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import workorderBanner from "../../../../assets/product/workorderBanner.png";

export default {
  setup() {
    return reactive({
      workorderBanner: workorderBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.workorder-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .workorder-banner {
    min-width: 1180px;
  }
}
.workorder-banner img {
 width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 34%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #fff;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #fff;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
